import React from 'react'
import PropTypes from 'prop-types'
import Modal from './Modal'
import { Grid, GridColumn, GridRow } from 'semantic-ui-react'

const ErrorAlert = ({ id, content, onClose }) => {
  return <Modal
    id={id}
    closeIcon
    closeOnDimmerClick
    open={true}
    onClose={() => onClose()}
  >
    <Grid divided='vertically'>
      <GridRow>
        <GridColumn width={16}>
          <h4>Error Encountered</h4>
        </GridColumn>
      </GridRow>
      <GridRow>
        <GridColumn width={16}>
          <p>{content}</p>
        </GridColumn>
      </GridRow>
    </Grid>
  </Modal>
}

ErrorAlert.propTypes = {
  /** A unique DOM Element ID */
  id: PropTypes.string,
  /** The content of the error message */
  content: PropTypes.node,
  /** An error alert can call a provided callback function when modal is closed */
  onClose: PropTypes.func
}

export default ErrorAlert